export const GET_REPRISE_PAIEMENT_INFORMATION = {
  REQUEST: "reprise_paiement/REPRISE_PAIEMENT_INFORMATION/GET/REQUEST",
  SUCCESS: "reprise_paiement/REPRISE_PAIEMENT_INFORMATION/GET/SUCCESS",
  FAILURE: "reprise_paiement/REPRISE_PAIEMENT_INFORMATION/GET/FAILURE"
};
